{
	"title": "Informe de gestión",
	"exportToExcel": "Exportar a excel",
	"exportToPDF": "Exportar a PDF",
	"exportButton": "Exportar DRE",
	"excelTitles": {
		"incomeList": "Ingresos",
		"costsList": "Costos",
		"expensesList": "Gastos"
	},
	"periodSelect": {
		"fifteen": "Últimos 15 días",
		"thirty": "Últimos 30 días",
		"sixty": "Últimos 60 días",
		"selectPeriod": "Seleccionar periodo"
	},
	"description": "El DRE de Gestión ayuda a analizar la salud financiera y los resultados de pérdidas o ganancias de una operación para equilibrar los gastos y aumentar los ingresos, optimizando costos y generando ganancias.",
	"periodDescription": "Mostrando valores consolidados desde {{since}} hasta {{until}}",
	"tabs": {
		"summary": "Resumen",
		"overview": "Descripción general"
	},
	"period": "Período",
	"applyDate": "Aplique la fecha",
	"table": {
		"level": "Nivel",
		"income": "Ingresos",
		"costs": "Costos",
		"expenses": "Gastos",
		"description": "Descripción",
		"total": "Total",
		"contribution": "Margen de contribución",
		"noData": "Sin datos",
		"summaries": {
			"totalIncome": "Total ingresos",
			"totalCosts": "Total costos",
			"totalExpenses": "Total gastos",
			"totalPeriod": "Total del Periodo"
		}
	}
}
